import IncidentData from "../../data/incidents.data";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  logo: {
    width: 84,
    height: 70,
    marginLeft: "auto",
    marginRight: "auto",
  },
  titleContainer: {
    marginTop: 24,
  },
  reportTitle: {
    color: "#3778C2",
    letterSpacing: 4,
    fontSize: 25,
    textAlign: "center",
    textTransform: "uppercase",
  },
  reportDescription: {
    fontSize: 12,
    marginBottom: 10,
  },
  row: {
    flexDirection: "column",
    borderBottomWidth: 1,
    fontSize: 12,
    fontStyle: "bold",
  },
  description: {
    width: "100%",
  },
  total: {
    width: "100%",
  },
});

export type HealthEventFormTypes = {
  formData: {
    eventDate: string;
    eventTime: string;
    eventMoment: string;
    eventLocation: string;
    precisionTypeEvent: string;
    eventDescription: string;
    consequences: string;
    emsContacted: string;
    hospitalization: string;
    insuranceBeNotified: string;
    insuranceBeenNotified: string;
    localAuthorityBeNotified: string;
    localAuthorityBeenNotified: string;
    parentsBeenInformed: string;
    securityLevel: string;
    aftercare: string;
    childAbsence: string;
    supervisionRateRespected: string;
    usualTeam: string;
    professionalNames: string;
    immediateCorrectiveActions: string;
    riskRelatedEvent: string;
    eventAvoidedSafer: string;
    recurrence: string;
    ageOfChild: string;
    printeventDate: boolean;
    printeventTime: boolean;
    printeventMoment: boolean;
    printeventLocation: boolean;
    printprecisionTypeEvent: boolean;
    printeventDescription: boolean;
    printconsequences: boolean;
    printemsContacted: boolean;
    printhospitalization: boolean;
    printinsuranceBeNotified: boolean;
    printinsuranceBeenNotified: boolean;
    printlocalAuthorityBeNotified: boolean;
    printlocalAuthorityBeenNotified: boolean;
    printparentsBeenInformed: boolean;
    printsecurityLevel: boolean;
    printaftercare: boolean;
    printchildAbsence: boolean;
    printsupervisionRateRespected: boolean;
    printusualTeam: boolean;
    printprofessionalNames: boolean;
    printimmediateCorrectiveActions: boolean;
    printriskRelatedEvent: boolean;
    printeventAvoidedSafer: boolean;
    printrecurrence: boolean;
    printageOfChild: boolean;
  };
};

export const IncidentsPDF = ({ formData }: HealthEventFormTypes) => {
  const { t } = useTranslation();

  const formatImmidiatData = () => {
    return formData["immediateCorrectiveActions"]
      .split("-,-")
      .map((element, index) => {
        return (
          <View key={element} style={{ flexDirection: "row", marginBottom: 4 }}>
            <Text style={{ marginHorizontal: 8 }}> {++index} - </Text>
            <Text>{t(element)}.</Text>
            <Text style={{ minWidth: "100%" }}></Text>
          </View>
        );
      });
  };
  const formatIncidentsData = () => {
    return formData["riskRelatedEvent"].split("-,-").map((element, index) => {
      return (
        <View key={element} style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={{ marginHorizontal: 8 }}> {++index} - </Text>
          <Text>{t(element)}.</Text>
          <Text style={{ minWidth: "100%" }}></Text>
        </View>
      );
    });
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.titleContainer}>
          <Text style={styles.reportTitle}>{t(IncidentData.title)}</Text>
          <Text style={styles.reportDescription}>
            {t(IncidentData.description.i18nKey)}
          </Text>
        </View>
        {IncidentData.fields.map((field, index) => {
          if (field.name === "eventDate" && formData["printeventDate"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["eventDate"])}
                </Text>
              </View>
            );
          } else if (field.name === "eventTime" && formData["printeventTime"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["eventTime"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "eventMoment" &&
            formData["printeventMoment"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["eventMoment"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "eventLocation" &&
            formData["printeventLocation"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["eventLocation"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "ageOfChild" &&
            formData["printageOfChild"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["ageOfChild"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "precisionTypeEvent" &&
            formData["printprecisionTypeEvent"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["precisionTypeEvent"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "eventDescription" &&
            formData["printeventDescription"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["eventDescription"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "consequences" &&
            formData["printconsequences"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["consequences"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "emsContacted" &&
            formData["printemsContacted"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["emsContacted"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "hospitalization" &&
            formData["printhospitalization"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["hospitalization"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "childAbsence" &&
            formData["printchildAbsence"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["childAbsence"])}
                </Text>
              </View>
            );
          } else if (field.name === "aftercare" && formData["printaftercare"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["aftercare"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "securityLevel" &&
            formData["printsecurityLevel"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["securityLevel"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "parentsBeenInformed" &&
            formData["printparentsBeenInformed"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["parentsBeenInformed"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "insuranceBeNotified" &&
            formData["printinsuranceBeNotified"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["insuranceBeNotified"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "insuranceBeenNotified" &&
            formData["printinsuranceBeenNotified"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["insuranceBeenNotified"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "localAuthorityBeNotified" &&
            formData["printlocalAuthorityBeNotified"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["localAuthorityBeNotified"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "localAuthorityBeenNotified" &&
            formData["printlocalAuthorityBeenNotified"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["localAuthorityBeenNotified"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "supervisionRateRespected" &&
            formData["printsupervisionRateRespected"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["supervisionRateRespected"])}
                </Text>
              </View>
            );
          } else if (field.name === "usualTeam" && formData["printusualTeam"]) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["usualTeam"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "professionalNames" &&
            formData["printprofessionalNames"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["professionalNames"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "immediateCorrectiveActions" &&
            formData["printimmediateCorrectiveActions"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>{formatImmidiatData()}</Text>
              </View>
            );
          } else if (
            field.name === "riskRelatedEvent" &&
            formData["printriskRelatedEvent"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>{formatIncidentsData()}</Text>
              </View>
            );
          } else if (
            field.name === "eventAvoidedSafer" &&
            formData["printeventAvoidedSafer"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["eventAvoidedSafer"])}
                </Text>
              </View>
            );
          } else if (
            field.name === "recurrence" &&
            formData["printrecurrence"]
          ) {
            return (
              <View key={index} style={styles.row}>
                <Text style={styles.total}>{t(field.label)}</Text>
                <Text style={styles.description}>
                  {t(formData["recurrence"])}
                </Text>
              </View>
            );
          }
          return null;
        })}
      </Page>
    </Document>
  );
};
